import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "(Tổng hợp từ số liệu của Sở Kế hoạch - Đầu tư)")
], -1)
const _hoisted_4 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian báo cáo: ", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "* Nếu có nhiều nghề trong một cơ sở sản xuất, lấy tên nghề chính (sản xuất sản phẩm chủ yếu hoặc chiếm trên 50% số người lao động)")
], -1)
const _hoisted_14 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_15 = { class: "p-fluid" }
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "* Nếu có nhiều nghề trong một cơ sở sản xuất, lấy tên nghề chính (sản xuất sản phẩm chủ yếu hoặc chiếm trên 50% số người lao động)")
], -1)
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_21 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_22 = { class: "p-fluid" }
const _hoisted_23 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_24 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_28 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_31 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_32 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_33 = { class: "p-fluid" }
const _hoisted_34 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_35 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_36 = { class: "p-fluid" }
const _hoisted_37 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_38 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Số cơ sở được quan trắc môi trường lao động", -1)
const _hoisted_40 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cơ sở báo cáo", -1)
const _hoisted_42 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_43 = { class: "p-fluid" }
const _hoisted_44 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_45 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", null, "(1): Tổng số mẫu quan trắc; (2): Tổng số mẫu không đạt")
], -1)
const _hoisted_47 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_48 = { class: "p-fluid" }
const _hoisted_49 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_50 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", null, "(1): Tổng số mẫu quan trắc; (2): Tổng số mẫu không đạt")
], -1)
const _hoisted_52 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_53 = { class: "p-fluid" }
const _hoisted_54 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_55 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_56 = { class: "p-fluid" }
const _hoisted_57 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_58 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_59 = { class: "p-fluid" }
const _hoisted_60 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_61 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Số cơ sở có báo cáo", -1)
const _hoisted_63 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cơ sở lao động trong phạm vi quản lý", -1)
const _hoisted_65 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "Ghi chú:"),
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "- Cột 2, 4: Tổng số người lao động nghỉ ốm, nghỉ do tai nạn lao động."),
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "- Cột 6: Tổng số người lao động tiếp xúc với yếu tố có hại gây bệnh nghề nghiệp."),
  /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "- Cột 3, 5, 7: Số ngày nghỉ do ốm, tai nạn lao động và bệnh nghề nghiệp.")
], -1)
const _hoisted_67 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_68 = { class: "p-fluid" }
const _hoisted_69 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Số cơ sở có báo cáo", -1)
const _hoisted_72 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cơ sở lao động", -1)
const _hoisted_74 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_75 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_76 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_77 = { class: "p-fluid" }
const _hoisted_78 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_79 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_80 = { class: "p-fluid" }
const _hoisted_81 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_82 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", null, "Số cơ sở có báo cáo", -1)
const _hoisted_84 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cơ sở lao động trong phạm vi quản lý", -1)
const _hoisted_86 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_87 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_88 = { class: "p-fluid" }
const _hoisted_89 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_90 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", null, "Số cơ sở lao động có khám BNN", -1)
const _hoisted_92 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cơ sở có nguy cơ", -1)
const _hoisted_94 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_95 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_96 = { class: "p-fluid" }
const _hoisted_97 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_98 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_99 = { class: "p-fluid" }
const _hoisted_100 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_101 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_102 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_103 = { class: "p-fluid" }
const _hoisted_104 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_105 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_106 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_107 = { class: "p-fluid" }
const _hoisted_108 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_109 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_110 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "I. Cơ sở lao động trong phạm vi quản lý" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_Calendar, {
                    modelValue: $setup.baoCao.thoiGianBC,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.thoiGianBC) = $event)),
                    touchUI: "",
                    view: "month",
                    dateFormat: "mm/yy"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCao.coSoLaoDongTrongPVQLs,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ColumnGroup, { type: "header" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Loại cơ sở lao động",
                                rowspan: 3
                              }),
                              _createVNode(_component_Column, {
                                header: "Số cơ sở",
                                colspan: 3
                              }),
                              _createVNode(_component_Column, {
                                header: "Số người lao động",
                                colspan: 6
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Tổng số",
                                rowspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Số trực thuộc bộ, ngành",
                                rowspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Số cơ sở có yếu tố có hại, nguy hiểm",
                                rowspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Tại tất cả các cơ sở",
                                colspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Tại các cơ sở có yếu tố có hại, nguy hiểm (YTCHNH)",
                                colspan: 4
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Tổng số",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số nữ",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Tổng số",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số nữ",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số NLĐ tiếp xúc trực tiếp với YTCHNH",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số nữ tiếp xúc trực tiếp với YTCHNH",
                                colspan: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiCSLD",
                        header: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Tổng số"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soTrucThuoc,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTrucThuoc) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soCSCoYeuToCoHai",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soCSCoYeuToCoHai,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSCoYeuToCoHai) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoCoSo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoCoSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCoSo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongNuCoSo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongNuCoSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongNuCoSo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoCoSoCoYeuTo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoCoSoCoYeuTo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCoSoCoYeuTo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongNuCoSoCoYeuTo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongNuCoSoCoYeuTo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongNuCoSoCoYeuTo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoLDTiepXucTrucTiep",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoLDTiepXucTrucTiep,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoLDTiepXucTrucTiep) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoNuTiepXucTrucTiep",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoNuTiepXucTrucTiep,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNuTiepXucTrucTiep) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ColumnGroup, { type: "footer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                footer: "Tổng cộng",
                                colspan: 1,
                                footerStyle: "text-align:left"
                              }),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(1)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(2)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(3)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(4)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(5)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(6)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(7)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(8)
                              }, null, 8, ["footer"]),
                              _createVNode(_component_Column, {
                                footer: $setup.totalCSLD(9)
                              }, null, 8, ["footer"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "II. Phân loại cơ sở lao động theo ngành nghề và quy mô" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Panel, { header: "1. Phân loại đối với tất cả các cơ sở lao động trong phạm vi quản lý" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.phanLoaiCoSoLaoDongTheoNghes,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Loại ngành nghề",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhỏ, siêu nhỏ dưới 100 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Cỡ vừa 100-200 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Cỡ lớn > 200 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width:3rem"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "loaiNganhNghe",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSDuoi100,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSDuoi100) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDDuoi100,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDDuoi100) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSDuoi200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSDuoi200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDDuoi200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDDuoi200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSTren200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSTren200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDTren200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDTren200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoCS,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCS) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoLDTiepXucTrucTiep",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNLD,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNLD) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLD(8)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_13
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Panel, { header: "2. Phân loại đối với cơ sở lao động có yếu tố có hại, nguy hiểm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.phanLoaiCoSoLaoDongNguyHais,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Loại ngành nghề",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhỏ, siêu nhỏ dưới 100 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Cỡ vừa 100-200 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Cỡ lớn > 200 NLĐ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số CS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số NLĐ",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width:3rem"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "loaiNganhNghe",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSDuoi100,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSDuoi100) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDDuoi100,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDDuoi100) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSDuoi200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSDuoi200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDDuoi200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDDuoi200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soCSTren200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSTren200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNLDTren200,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNLDTren200) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoCS,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCS) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoLDTiepXucTrucTiep",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNLD,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNLD) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPLCSLDYTNH(8)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_18
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "III. Lập hồ sơ vệ sinh lao động" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCao.hoSoVeSinhLaoDongs,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ColumnGroup, { type: "header" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Các cơ sở lao động thuộc phạm vi quản lý",
                                colspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Cơ sở lao động có yếu tố nguy hiểm, có hại",
                                colspan: 2
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Tổng số cơ sở",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số cơ sở lập hồ sơ vệ sinh lao động",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Tổng số cơ sở",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số cơ sở lập hồ sơ vệ sinh lao động",
                                colspan: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Tổng số"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoCSQL,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCSQL) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soCSLapHSQL,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSLapHSQL) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soCSCoYeuToCoHai",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSoCSNH,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCSNH) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoCoSo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soCSLapHSNH,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCSLapHSNH) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "IV. Tổ chức bộ phận y tế tại cơ sở lao động" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Panel, { header: "1. Phân loại cơ sở lao động theo hình thức tổ chức bộ phận y tế" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.toChucBoPhanYTeTaiCSLDs,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Loại cơ sở sản xuất",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Hình thức tổ chức bộ phận y tế tại cơ sở lao động",
                                          colspan: 5
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Hợp đồng với cơ sở khám bệnh, chữa bệnh",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng cộng",
                                          rowspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Có trạm/phòng y tế",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bệnh viện",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Phòng khám",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Khác",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số cơ sở có tổ chức y tế",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "loaiCSSX",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tramYTe,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tramYTe) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.benhVien,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhVien) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.phongKham,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.phongKham) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.khac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.khac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoCSYT,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCSYT) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.hopDongVoiCSKB,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.hopDongVoiCSKB) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongCong,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongCong) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalToChuc(7)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Panel, { header: "2. Trình độ người làm công tác Y tế tại các cơ sở lao động" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.trinhDoNguoiLamCongTacYTes,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Loại cơ sở sản xuất",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số người làm công tác Y tế",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Trình độ người làm công tác y tế",
                                          colspan: 6
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Bác sĩ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bác sĩ y tế dự phòng",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Cử nhân điều dưỡng",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Y sỹ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Điều dưỡng trung học",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Hộ sinh viên",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "loaiCSSX",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNguoiLamCongTacYTe,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNguoiLamCongTacYTe) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.bacSi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.bacSi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.bacSiYTeDuPhong,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.bacSiYTeDuPhong) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.cuNhanDieuDuong,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.cuNhanDieuDuong) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ySy,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ySy) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.dieuDuongTrungHoc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.dieuDuongTrungHoc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.hoSinhVien,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.hoSinhVien) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalCongTacYT(7)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Panel, { header: "3. Lực lượng sơ cấp cứu tại các cơ sở lao động" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.lucLuongSoCuus,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Loại cơ sở sản xuất",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người tham gia lực lượng sơ cứu",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Trong đó nữ",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "loaiCSSX",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalSo(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalSo(2)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "V. Kết quả quan trắc môi trường lao động trong kỳ báo cáo" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_InputText, {
                    id: "soCSQTMTLD",
                    type: "text",
                    modelValue: $setup.baoCao.soCSQTMTLD,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCao.soCSQTMTLD) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_InputText, {
                    id: "tongSoCSQT",
                    type: "text",
                    modelValue: $setup.baoCao.tongSoCSQT,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baoCao.tongSoCSQT) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_Panel, { header: "1. Kết quả quan trắc các yếu tố vi khí hậu và vật lý, hóa học trong môi trường lao động" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addKetQua
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.ketQuaQuanTracViKhiHaus,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên cơ sở",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số người lao động",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người tiếp xúc",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhiệt độ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Độ ẩm",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tốc độ gió",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Ánh sáng",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Ồn",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Rung",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "HK độc",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Phóng xạ",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Điện, Từ trường",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Yếu tố khác",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "",
                                      type: "text",
                                      modelValue: slotProps.data.tenCoSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCoSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNguoiLD,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNguoiLD) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNguoiTiepXuc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiTiepXuc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.nhietDo.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.nhietDo.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.nhietDo.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.nhietDo.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.doAm.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.doAm.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.doAm.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.doAm.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tocDoGio.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tocDoGio.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tocDoGio.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tocDoGio.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.anhSang.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.anhSang.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.anhSang.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.anhSang.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.on.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.on.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.on.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.on.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.rung.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.rung.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.rung.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.rung.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.hKDoc.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.hKDoc.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.hKDoc.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.hKDoc.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.phongXa.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.phongXa.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.phongXa.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.phongXa.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.dienTuTruong.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.dienTuTruong.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.dienTuTruong.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.dienTuTruong.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.yeuToKhac.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.yeuToKhac.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.yeuToKhac.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.yeuToKhac.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(8)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(9)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(10)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(11)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(12)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(13)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(14)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(15)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(16)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(17)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(18)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(19)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(20)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(21)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaQuanTrac(22)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_46
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Panel, { header: "2. Kết quả quan trắc yếu tố bụi trong môi trường lao động" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addKetQuaBui
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.ketQuaQuanTracYeuToBuis,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên cơ sở",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số người lao động",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người tiếp xúc",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bụi toàn phần",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bụi hô hấp",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bụi silic",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bụi khác",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "tenCoSo",
                                      type: "text",
                                      modelValue: slotProps.data.tenCoSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCoSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNguoiLD,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNguoiLD) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNguoiTiepXuc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiTiepXuc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiToanPhan.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiToanPhan.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiToanPhan.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiToanPhan.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiHoHap.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiHoHap.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiHoHap.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiHoHap.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiSilic.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiSilic.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiSilic.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiSilic.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiKhac.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiKhac.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.buiKhac.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.buiKhac.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo.soMauQuanTrac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo.soMauQuanTrac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"50px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo.soMauKhongDat,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo.soMauKhongDat) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(8)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(9)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(10)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(11)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalKetQuaBui(12)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_51
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_Panel, { header: "3. Kết quả đánh giá các yếu tố tiếp xúc nghề nghiệp và yếu tố tâm sinh lý và ec-gô-nô-my" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addDanhGia
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.danhGiaCacYeuTos,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên cơ sở",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số người lao động",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Đánh giá các yếu tố tiếp xúc nghề nghiệp (yếu tố vi sinh vật/gây dị ứng, mẫn cảm/gây ung thư/dung môi)",
                                          colspan: 3
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Yếu tố tâm sinh lý và ec-gô-nô-my",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Yếu tố tiếp xúc",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người tiếp xúc",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Kết quả đánh giá",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người được đánh giá",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Kết quả đánh giá",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "tenCoSo4",
                                      type: "text",
                                      modelValue: slotProps.data.tenCoSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCoSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoNguoiLD,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoNguoiLD) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "yeuToTiepXuc",
                                      type: "text",
                                      modelValue: slotProps.data.yeuToTiepXuc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.yeuToTiepXuc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNguoiTiepXuc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiTiepXuc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "ketQuaDanhGia",
                                      type: "text",
                                      modelValue: slotProps.data.ketQuaDanhGia,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDanhGia) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.soNguoiDuocDanhGia,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDuocDanhGia) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "ketQuaDanhGiaTamSinhLy",
                                      type: "text",
                                      modelValue: slotProps.data.ketQuaDanhGiaTamSinhLy,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDanhGiaTamSinhLy) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalDanhGiaCacYeuTo(6)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VI. Tình hình sức khỏe và bệnh tật" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_Panel, { header: "1. Tình hình nghỉ ốm, tai nạn lao động và bệnh nghề nghiệp" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _hoisted_62,
                            _createVNode(_component_InputText, {
                              id: "soCSBCSK",
                              type: "text",
                              modelValue: $setup.baoCao.soCSBCSK,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.baoCao.soCSBCSK) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _hoisted_64,
                            _createVNode(_component_InputText, {
                              id: "tongSoCSVP",
                              type: "text",
                              modelValue: $setup.baoCao.tongSoCSVP,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCao.tongSoCSVP) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addTinhHinhSucKhoe
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.tinhHinhSucKhoes,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên cơ sở lao động",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Ốm",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tai nạn lao động",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Bệnh nghề nghiệp",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Số người",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số ngày ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số ngày ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số ngày ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số người",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số ngày ",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(1)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(2)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(3)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(4)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(5)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(6)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(7)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(8)",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "(9)",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "tenCoSo5",
                                      type: "text",
                                      modelValue: slotProps.data.tenCoSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCoSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.om.soNguoi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.om.soNguoi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.om.tongSoNgay,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.om.tongSoNgay) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.taiNanLaoDong.soNguoi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiNanLaoDong.soNguoi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.taiNanLaoDong.tongSoNgay,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiNanLaoDong.tongSoNgay) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.benhNgheNghiep.soNguoi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhNgheNghiep.soNguoi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.benhNgheNghiep.tongSoNgay,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhNgheNghiep.tongSoNgay) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo.soNguoi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo.soNguoi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo.tongSoNgay,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo.tongSoNgay) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTinhHinhSucKhoe(8)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_66
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_Panel, { header: "2." }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _createVNode(_component_InputText, {
                              id: "soCSBCBenh",
                              type: "text",
                              modelValue: $setup.baoCao.soCSBCBenh,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCao.soCSBCBenh) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createVNode(_component_InputText, {
                              id: "tongSoCSBenh",
                              type: "text",
                              modelValue: $setup.baoCao.tongSoCSBenh,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCao.tongSoCSBenh) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addNhomBenh
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.soCoSoBaoCaos,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          colspan: 1,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhóm bệnh",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "6 tháng đầu năm",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "6 tháng cuối năm",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "I. Số trường hợp mắc các loại bệnh thông thường:",
                                          colspan: 4
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenCoSo",
                                  header: "Nhóm bệnh"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "nhomBenh",
                                      type: "text",
                                      modelValue: slotProps.data.nhomBenh,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.nhomBenh) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "6 tháng đầu năm",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangDauNam.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "6 tháng cuối năm",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangCuoiNam.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalNhomBenh(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalNhomBenh(2)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.truongHopMacBenhNgheNghiep,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          colspan: 1,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhóm bệnh",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "6 tháng đầu năm",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "6 tháng cuối năm",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "II. Các trường hợp mắc bệnh nghề nghiệp",
                                          colspan: 4
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "nhomBenh",
                                  header: "Nhóm bệnh"
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "6 tháng đầu năm",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangDauNam.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "6 tháng cuối năm",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangCuoiNam.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalBenhNgheNghiep(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalBenhNgheNghiep(2)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.truongTaiNanLaoDong,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          colspan: 1,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nhóm bệnh",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Mắc",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Chết",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Mắc",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Chết",
                                          colspan: 1,
                                          style: {"width":"200px"}
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "III. Các trường hợp tai nạn lao động (Z04.2)",
                                          colspan: 6
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "nhomBenh",
                                  header: "Nhóm bệnh"
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangDauNam.mac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.mac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangDauNam.chet,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.chet) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangCuoiNam.mac,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.mac) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.sauThangCuoiNam.chet,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.chet) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTaiNanLaoDong(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTaiNanLaoDong(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTaiNanLaoDong(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalTaiNanLaoDong(4)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VII. Tình hình khám định kỳ và khám phát hiện, giám định bệnh nghề nghiệp" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_Panel, { header: "1. Phân loại sức khỏe:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _hoisted_83,
                            _createVNode(_component_InputText, {
                              id: "soCSBCPhanLoai",
                              type: "text",
                              modelValue: $setup.baoCao.soCSBCSK,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.baoCao.soCSBCSK) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createVNode(_component_InputText, {
                              id: "tongSoCSPhanLoai",
                              type: "text",
                              modelValue: $setup.baoCao.tongSoCSVP,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.baoCao.tongSoCSVP) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.phanLoaiSucKhoes,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "soNguoiDuocKSK",
                                  header: "Số  Khám SKĐK"
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Tổng số",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại I",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.loaiI,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiI) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại II",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.loaiII,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiII) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại III",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.loaiIII,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiIII) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại IV",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.loaiIV,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiIV) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại V",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.loaiV,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiV) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_Panel, { header: "2. Kết quả khám phát hiện bệnh nghề nghiệp" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _hoisted_91,
                            _createVNode(_component_InputText, {
                              id: "soCSBCPhatHien",
                              type: "text",
                              modelValue: $setup.baoCao.soCSBCPhatHien,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.baoCao.soCSBCPhatHien) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _hoisted_93,
                            _createVNode(_component_InputText, {
                              id: "tongSoCSPhatHien",
                              type: "text",
                              modelValue: $setup.baoCao.tongSoCSPhatHien,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.baoCao.tongSoCSPhatHien) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.ketQuaKhamPhatHienBenhs,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 3,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên bệnh nghề nghiệp",
                                          rowspan: 3
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "NLĐ được khám sức khỏe phát hiện BNN",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "NLĐ được chẩn đoán BNN",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "NLĐ được giám định BNN",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Kết quả giám định BNN",
                                          colspan: 6
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số nữ",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số nữ",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Số nữ",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "<5%",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "5 - 30%",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: ">=31%",
                                          colspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nữ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "TS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nữ",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "TS",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nữ",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tenBenh",
                                  header: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.phatBenhKhiKham.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.phatBenhKhiKham.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.phatBenhKhiKham.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.phatBenhKhiKham.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.duocChanDoanBenh.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocChanDoanBenh.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.duocChanDoanBenh.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocChanDoanBenh.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.duocGiamDinh.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocGiamDinh.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.duocGiamDinh.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocGiamDinh.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaDuoi5.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDuoi5.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaDuoi5.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDuoi5.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaTu5Den30.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTu5Den30.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaTu5Den30.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTu5Den30.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaTren31.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTren31.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "",
                                  style: {"width":"70px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.ketQuaTren31.nu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTren31.nu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(8)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(9)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(10)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(11)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalPhatHienBenh(12)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_component_Panel, { header: "3. Danh sách người mắc bệnh nghề nghiệp" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createVNode(_component_Toolbar, { class: "mb-6" }, {
                              start: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  label: "Thêm",
                                  severity: "secondary",
                                  icon: "pi pi-plus",
                                  class: "mr-2",
                                  onClick: $setup.addDanhSachBenh
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.danhSachMacBNNs,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "TT",
                                          rowspan: 2,
                                          style: {"width":"50px"}
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Họ tên bệnh nhân",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tuổi",
                                          colspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nghề khi bị BNN",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tuổi nghề",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Ngày phát hiện bệnh",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tên BNN",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tỷ lệ suy giảm KNLĐ",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Công việc hiện nay",
                                          rowspan: 2
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Nam",
                                          rowspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nữ",
                                          rowspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Stt",
                                  headerStyle: "width: 50px"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Tổng số"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "hoTenBenhNhan",
                                      type: "text",
                                      modelValue: slotProps.data.hoTenBenhNhan,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.hoTenBenhNhan) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại I",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tuoiNam,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNam) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại II",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tuoiNu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNu) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại III",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "ngheKhiBNN",
                                      type: "text",
                                      modelValue: slotProps.data.ngheKhiBNN,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ngheKhiBNN) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại IV",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tuoiNghe,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNghe) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại V",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_Calendar, {
                                      modelValue: slotProps.data.ngayPhatHienBenh,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.ngayPhatHienBenh) = $event),
                                      touchUI: "",
                                      dateFormat: "dd/mm/yy"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại III",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "tenBNN",
                                      type: "text",
                                      modelValue: slotProps.data.tenBNN,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBNN) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại IV",
                                  style: {"width":"100px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tyLeSuyGiam,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tyLeSuyGiam) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "",
                                  header: "Loại IV",
                                  style: {"width":"200px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputText, {
                                      id: "congViecHienNay",
                                      type: "text",
                                      modelValue: slotProps.data.congViecHienNay,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.congViecHienNay) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          footer: "Tổng cộng",
                                          colspan: 2,
                                          footerStyle: "text-align:left"
                                        }),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(1)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(2)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(3)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(4)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(5)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(6)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(7)
                                        }, null, 8, ["footer"]),
                                        _createVNode(_component_Column, {
                                          footer: $setup.totalMacBenhNN(8)
                                        }, null, 8, ["footer"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VIII. Huấn luyện về y tế lao động và bệnh nghề nghiệp" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createVNode(_component_Panel, { header: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("div", _hoisted_105, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.huanLuyenVeYTLDs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 2,
                                            style: {"width":"50px"}
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Nội dung",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số cơ sở lao động được huấn luyện",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số người lao động được huấn luyện",
                                            colspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nữ",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width: 50px"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "noiDung",
                                    header: "Tổng số"
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại I",
                                    style: {"width":"200px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soCoSoLD,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCoSoLD) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại II",
                                    style: {"width":"200px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.tongSo,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại IV",
                                    style: {"width":"200px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soNu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ColumnGroup, { type: "footer" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            footer: "Tổng cộng",
                                            colspan: 2,
                                            footerStyle: "text-align:left"
                                          }),
                                          _createVNode(_component_Column, {
                                            footer: $setup.totalMacBenhNN(1)
                                          }, null, 8, ["footer"]),
                                          _createVNode(_component_Column, {
                                            footer: $setup.totalMacBenhNN(2)
                                          }, null, 8, ["footer"]),
                                          _createVNode(_component_Column, {
                                            footer: $setup.totalMacBenhNN(3)
                                          }, null, 8, ["footer"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReport
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_107, [
      _createElementVNode("div", _hoisted_108, [
        _createElementVNode("div", _hoisted_109, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}